export class UnknownIntegration extends Error {
  public constructor() {
    super()

    this.message = 'errors.unknownIntegration'
  }
}
